import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  toRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}))

const ConsentUpdateDetail = ({ isEnglish, activeTab }) => {
  const classes = useStyles()

  const DomesticContent = () => (
    <div className={classes.toRight}>
      <p>
        <em>
          {isEnglish
            ? `This Privacy Policy was last updated and effective on March 4, 2025`
            : `นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่  4 มีนาคม 2568`}
        </em>
      </p>
    </div>
  )

  const InterContent = () => (
    <div className={classes.toRight}>
      <p>
        <em>
          {isEnglish
            ? `This Privacy Policy was last updated and effective on March 4, 2025`
            : `นโยบายนี้แก้ไขล่าสุดและมีผลใช้บังคับตั้งแต่วันที่  4 มีนาคม 2568`}
        </em>
      </p>
    </div>
  )

  const OmsContent = () => (
    <div className={classes.toRight}>
      <p>
        <em>
          {isEnglish
            ? `ข้อมูลดังกล่าว อัพเดท ณ วันที่ 16 ตุลาคม 2568`
            : `ข้อมูลดังกล่าว อัพเดท ณ วันที่ 16 ตุลาคม 2568`}
        </em>
      </p>
    </div>
  )

  return (
    <>
      {activeTab === 0 && <DomesticContent />}
      {activeTab === 1 && <InterContent />}
      {activeTab === 2 && <OmsContent />}
    </>
  )
}

export default memo(ConsentUpdateDetail)
